import React, { useState } from "react";
import { theme } from "../theme.js";

export default function RequirementLicense({ 
  licenseChoice, 
  onLicenseChange 
}) {
  const options = [
    { name: "pps", label: "PPS seulement", value : "PPS" },
    { name: "license", label: "Licence seulement", value : "Licence" },
    { name: "pps_or_license", label: "PPS ou Licence", value : "PPS ou Licence" },
    { name: "none", label: "Aucun", value : "none" },
  ];

  return (
    <div style={styles.container}>
      <label style={styles.label}>Justificatif de Licence</label>
      <div style={styles.radioGroup}>
        {options.map((option) => (
          <label key={option.value} style={styles.radioLabel}>
            <input
              type="radio"
              name="licenseChoice"
              checked={licenseChoice?.name === option.name}
              onChange={() => onLicenseChange(option)}
              style={styles.radio}
            />
            {option.label}
          </label>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "16px",
    backgroundColor: "#f9fafb",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    marginBottom: "16px",
  },
  label: {
    display: "block",
    fontWeight: "600",
    marginBottom: "12px",
    color: theme.colors.dark,
    fontSize: "14px",
  },
  radioGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "14px",
    color: theme.colors.dark,
  },
  radio: {
    marginRight: "8px",
    cursor: "pointer",
      accentColor: theme.colors.dark,
  },
};
